function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class MessagePortPolyfill {
    get onmessage() {
        return this._onmessage;
    }
    set onmessage(listener) {
        // setting onmessage will start the port, even if the listener is null.
        this._onmessage = listener;
        this.start();
    }
    dispatchEvent(event) {
        if (!this.started) {
            this.eventQueue.push(event);
            return true;
        }
        if (this._onmessage) {
            this._onmessage(event);
        }
        for (const listener of this.listeners){
            listener(event);
        }
        return true;
    }
    postMessage(message) {
        if (!this.otherPort) {
            return;
        }
        this.otherPort.dispatchEvent({
            data: message
        });
    }
    addEventListener(type, listener) {
        if (type !== 'message') {
            return;
        }
        this.listeners.add(listener);
    }
    removeEventListener(type, listener) {
        if (type !== 'message') {
            return;
        }
        this.listeners.delete(listener);
    }
    start() {
        // port can't be re-started once it's closed
        if (this.closed) {
            return;
        }
        this.started = true;
        while(this.eventQueue.length > 0){
            const event = this.eventQueue.shift();
            if (event) {
                this.dispatchEvent(event);
            }
        }
    }
    close() {
        this.started = false;
        this.closed = true;
    }
    constructor(){
        _define_property(this, "onmessageerror", null);
        _define_property(this, "otherPort", void 0);
        _define_property(this, "listeners", new Set());
        // MessagePort does not send messages unless it is started via start() or attaching .onmessage
        // https://developer.mozilla.org/en-US/docs/Web/API/MessagePort/start
        _define_property(this, "started", false);
        _define_property(this, "closed", false);
        _define_property(this, "_onmessage", null);
        // If the port is not yet started, messages will be queued for sending.
        _define_property(this, "eventQueue", []);
    }
}
class MessageChannelPolyfill {
    constructor(){
        _define_property(this, "port1", void 0);
        _define_property(this, "port2", void 0);
        this.port1 = new MessagePortPolyfill();
        this.port2 = new MessagePortPolyfill();
        this.port1.otherPort = this.port2;
        this.port2.otherPort = this.port1;
    }
}
export default MessageChannelPolyfill;

//# sourceMappingURL=MessageChannelPolyfill.js.map